/**
 * @file: 剪切板
 * @author: xiaolong.huang@dmall.com
 */

import UUID from '../utils/uuid';
import Storage from '../storage/index';
import Utils from '../utils/util';

async function set(params: ClipboardSetParams): Promise<any> {
    let dataList: Array<FreeObjMap> = makeStorePageList(params, 4);

    await Storage.clearTable('clipboard');
    await Storage.addGroup('clipboard', dataList);
}

function get(params: ClipboardGetParams): Promise<any> {
    return Storage.get({
        tableName: 'clipboard',
        query: {
            type: params.type
        }
    }).then((pageList: Array<FreeObjMap>) => {
        return Promise.resolve(mergeStorePage(pageList));
    });
}

// 剪切板数据存储切片
function makeStorePageList(params: ClipboardSetParams, pageSize: number): Array<FreeObjMap> {
    let result: Array<FreeObjMap> = [];
    let page = [];
    let len: number = params.data.length;

    for (let i = 0; i < len; i++) {
        page.push(params.data[i]);
        if ((i + 1) % pageSize === 0 || i === len - 1) {
            result.push({
                type: params.type,
                extendParams: params.extendParams,
                data: Utils.deepCopy(page)
            });
            page = [];
        }
    }

    return result;
}

// 剪切板数据存储切片合并
function mergeStorePage(pageList: Array<FreeObjMap>): Array<FreeObjMap> {
    if (!pageList.length) {
        return [];
    }
    let result: Array<FreeObjMap> = [{
        type: pageList[0].type,
        extendParams: pageList[0].extendParams,
        data: []
    }];

    pageList.forEach((page: FreeObjMap): void => {
        page.data.forEach((dataItem: FreeObjMap): void => {
            result[0].data.push(dataItem);
        });
    });

    return result;
}

export default {
    set,
    get,
    makeStorePageList,
    mergeStorePage
};
